<template>
  <div>
    <div class="flex flex-wrap flex-col justify-center items-center">
      <div class="flex flex-wrap flex-col p-6 bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
          <p style="font-size:60px; font-weight:bold;"><strong>Refund Policy</strong></p>
          <p style="font-size:30px; font-weight:bold;"><strong>14 Days Money Back Guarantee</strong></p>
          <p style="font-size:16px; font-weight:bold;">The 14 Days Money Back Guarantee applies if...</p>
          <ul class="text-start" style="list-style-type:none;">
            <li>
              1. you have purchased a subscription for the first time
            </li>
            <li>
              2. the subscription was purchased within the last 14 days,
            </li>
            <li>
              3. you are not satisfied with the result quality and have no se for cutout images generated by simpleish.io,
            </li>
            <li>
              4. you have processed  total of less than 50 images in any resolution, and  
            </li>
            <li>
              5. your account, you personally and your company have not made use of the 14 Days Money Back Guarantee before.
            </li>
          </ul>
          <p style="font-size:16px; font-weight:bold;">To place a refund request, you would have to fill out <a @click="goToContact"><i>this form</i></a>. We will then review your request within 10 days and contact you via email.</p>
          <span style="font-size:30px; font-weight:bold;"><strong>Other refunds</strong></span>
          <p style="font-size:16px;">Purchases outside of the 14 Days Money Back Guarantee are generally non-refundable. If you are unhappy with your subscription you can cancel it any time. If you ave any questions, feel free to <i>contact us</i>.</p>
      </div>
    </div>

  <!--<v-row>
    <v-col>
      <span style="font-size:60px; font-weight:bold;"><strong>Refund Policy</strong></span>
    </v-col>
  </v-row>
  <v-row justify="center" align="center">
    <v-col cols="6" style="text-align:start;">
        <span style="font-size:30px; font-weight:bold;"><strong>14 Days Money Back Guarantee</strong></span>
        <p style="font-size:16px; font-weight:bold;">The 14 Days Money Back Guarantee applies if...</p>
        <ul style="list-style-type:none;">
          <li>
            1. you have purchased a subscription for the first time
          </li>
          <li>
            2. the subscription was purchased within the last 14 days,
          </li>
          <li>
            3. you are not satisfied with the result quality and have no se for cutout images generated by simpleish.io,
          </li>
          <li>
            4. you have processed  total of less than 50 images in any resolution, and  
          </li>
          <li>
            5. your account, you personally and your company have not made use of the 14 Days Money Back Guarantee before.
          </li>
        </ul>
        <p style="font-size:16px; font-weight:bold;">To place a refund request, you would have to fill out <a href="#" @click="goToContact"><i>this form</i></a>. We will then review your request within 10 days and contact you via email.</p>
        <span style="font-size:30px; font-weight:bold;"><strong>Other refunds</strong></span>
        <p style="font-size:16px;">Purchases outside of the 14 Days Money Back Guarantee are generally non-refundable. If you are unhappy with your subscription you can cancel it any time. If you ave any questions, feel free to <i>contact us</i>.</p>
      
    </v-col>
  </v-row>-->
</div>
</template>

<script>

export default {
  name: "Refunds",
  components: {
  },
  props: {
  },
  data() {
    return {
      origin: 'http://localhost:8080',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  mounted: function () {
  },
  methods: {
    goToContact() {
      this.$router.push('/contact-form');
    },
  },
};
</script>